// extracted by mini-css-extract-plugin
export var accordion = "_ih-0";
export var chevron = "_ih-3";
export var closed = "_ih-2";
export var content = "_ih-4";
export var open = "_ih-1";
export var rotate = "_ih-5";